// removed by extract-text-webpack-plugin
module.exports = {"root":"AutosuggestCarTypes-module-root-2Xe7x","cross-btn":"AutosuggestCarTypes-module-cross-btn-1UTNg","crossBtn":"AutosuggestCarTypes-module-cross-btn-1UTNg","is-car-plate-search":"AutosuggestCarTypes-module-is-car-plate-search-2Tf2r","isCarPlateSearch":"AutosuggestCarTypes-module-is-car-plate-search-2Tf2r","hint":"AutosuggestCarTypes-module-hint-tqS7U","home":"AutosuggestCarTypes-module-home-1Bs1D"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AutosuggestCarTypes/AutosuggestCarTypes.module.scss
// module id = 1013
// module chunks = 0